import React, { useEffect, useRef, useState } from 'react'
import styles from './styles.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { supportActions } from '../actions'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import { useTranslation } from 'react-i18next'
import { formatDate, getDateTimeFormat11 } from 'srcReact/helpers/datetimeHelper'
import { download, downloadMedia } from 'srcReact/helpers/fileHelper'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import Label from 'srcReact/components/common2/Label'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import IconButton from 'srcReact/components/common2/IconButton'
import ShowMoreCompoents from 'srcReact/components/common2/ShowMoreCompoents'
import Button from 'srcReact/components/common2/Button'
import { commonActions } from 'srcReact/components'
import BackNavigation from 'srcReact/components/common2/BackNavigation'
import { redirectToPage } from 'srcReact/helpers/history'
import { AlertContainer, alertActions } from 'srcReact/Alert'
import Spinner from 'srcReact/components/common2/Spinner'

function TicketDetails(props) {
  const dispatch = useDispatch()
  const ticketId = props.match.params.id
  const orgId = getCurrentOrgId()
  const { t } = useTranslation()
  const fileInputRef = useRef(null)

  const [showMessageField, setShowMessageField] = useState(false)
  const [files, setFiles] = useState([])
  const [actions, setActions] = useState([])
  const [sendMessageTriggred, setSendMessageTriggred] = useState(false)
  const [message, setMessage] = useState({
    value: '',
    placeholder: t('contact.ticket.messagePlaceholder'),
    hasError: false,
    errorMessage: ''
  })

  const {
    alert,

    support: {
      contact: { loading: messageLoading, success },
      ticket: { data, loading, error }
    },
    common: {
      isNative,
      fileCreation: { files: uploadedFiles, loadingFile }
    }
  } = useSelector((state) => state)

  useEffect(() => {
    dispatch(supportActions.getTicketById(orgId, ticketId))
    return () => {
      dispatch(supportActions.clearData())
    }
  }, [])

  useEffect(() => {
    //if ticket is open, then show the message area by default
    if (data?.statuses?.length > 0 && data.statuses[0].name !== 'Closed') {
      setShowMessageField(true)
    }
  }, [data?.statuses])
  useEffect(() => {
    if (sendMessageTriggred && !messageLoading && success) {
      setSendMessageTriggred(false)
      setShowMessageField(false)
      setMessage({
        ...message,
        value: '',
        hasError: false,
        errorMessage: ''
      })
      setFiles([])
    }
  }, [sendMessageTriggred, messageLoading, success])

  useEffect(() => {
    if (data?.actions?.length > 0) {
      setActions(data.actions.reverse())
    }
  }, [data?.actions])

  useEffect(() => {
    if (!loadingFile && uploadedFiles?.length > 0) {
      const fileIds = uploadedFiles?.map((file) => file.id).join(',')
      dispatch(
        supportActions.postTicket({
          id_organization: orgId,
          id_support_ticket_origin: ticketId,
          message: message.value,
          file_ids: fileIds
        })
      )
    }
  }, [uploadedFiles, loadingFile])

  async function onSelectFile(e) {
    const newFiles = e.target.files
    if (newFiles?.length > 0) {
      setFiles([...files, ...newFiles])
    }
  }

  function removeFile(fileIndex) {
    const updatedFiles = files.toSpliced(fileIndex, 1)
    setFiles(updatedFiles)
  }

  const openFileDialog = (e) => {
    e.stopPropagation()
    fileInputRef.current.click()
  }

  const handleChange = (e) => {
    if (e && e.target) {
      const { name, value } = e.target
      setMessage({ ...message, value: value, hasError: false })
    }
  }
  const sendMessage = () => {
    setSendMessageTriggred(true)
    if (files.length > 0) {
      dispatch(commonActions.fileCreation(files, { is_logged: 1, type: 'picture' }))
    } else {
      dispatch(
        supportActions.postTicket({
          id_organization: orgId,
          id_support_ticket_origin: ticketId,
          message: message.value
        })
      )
    }
  }

  return (
    <PageContainer pageTitle={t('contact.titleAuth')} withHeader={true} withFooter={false}>
      {alert && alert.message ? (
        <AlertContainer
          title={t('error.error_alert_title')}
          message={alert.message}
          show={!!alert.message}
          handleClose={() => dispatch(alertActions.clear())}
        />
      ) : null}
      <div className={styles.ticketDataWrapper}>
        <BackNavigation
          className={styles.back}
          customHandleBack={() => redirectToPage(`/0/support/tickets`, isNative)}
        />
        <h1 className={styles.title}>{`${t('contact.ticket.ticket')} n#${ticketId}`}</h1>
        {data ? (
          <div className={styles.data}>
            <div className={styles.field}>
              <h3>{`${t('formlabel.subject')}: `} </h3>
              <span>{data.subject}</span>
            </div>
            <div className={styles.actions}>
              {actions?.length > 0 &&
                actions.map((action) => (
                  <fieldset className={styles.fieldset}>
                    <legend className={styles.legend}>
                      {action.origin === 'user' ? t('global.you') : t('contact.mixrOrigin')}
                    </legend>
                    {/* <div className={styles.actionDetail}> */}
                    <p className={styles.datetime}>{formatDate(action.done_at, getDateTimeFormat11())}</p>

                    {action.message && <p className={styles.messageText}>{action.message}</p>}

                    {action.files?.length > 0 && (
                      <React.Fragment>
                        <p className={styles.label}>{`${t('contact.attachments')}: `}</p>
                        <div className={styles.attachments}>
                          {action.files.map((file) => (
                            <button
                              type='button'
                              onClick={() => download(file.url, file.name)}
                              className={styles.btnImage}>
                              <img src={file.url} />
                            </button>
                          ))}
                        </div>
                      </React.Fragment>
                    )}
                    {/* </div> */}
                  </fieldset>
                ))}
            </div>
            <ShowMoreCompoents
              showText={t('messenger.sendMessage')}
              hideText={t('contact.ticket.closeMessage')}
              isShowMore={showMessageField}
              className={styles.showMessageContainer}
              showMoreButtonCSS={styles.btnShowMore}
              setIsShowMore={setShowMessageField}>
              <div className={styles.sendMessageContent}>
                <div className={styles.messageWrapper}>
                  <Label className={styles.label}>{t('formlabel.message')}</Label>
                  <textarea
                    name='message'
                    className={`${styles.textarea} ${message.hasError ? styles.error : ''}`}
                    placeholder={message.placeholder}
                    onChange={(e) => handleChange(e)}
                    aria-label={message.placeholder}
                    defaultValue={message.value}
                    maxLength={appConstantSettings.MESSAGE_MAX_LEN}
                  />
                  {message.hasError && <ErrorMessage text={message.errorMessage} />}
                </div>
                <div className={`${styles.attachmentWrapper}`}>
                  <Label className={styles.label}>{t('contact.attachmentsOpt')}</Label>
                  <button type='button' className={styles.btnFile} onClick={openFileDialog}>
                    <span>{t('global.select')}</span>
                    <input
                      ref={fileInputRef}
                      className={styles.fileInput}
                      accept='image/*'
                      type='file'
                      multiple
                      onChange={onSelectFile}
                    />
                  </button>
                  <div className={styles.attachedFiles}>
                    {files.map((file, index) => (
                      <div className={styles.file}>
                        <span className={styles.filename}>{file.name}</span>
                        <IconButton
                          type='button'
                          iconName='close24'
                          iconSize='large24'
                          className={styles.btnRemove}
                          onClick={() => removeFile(index)}
                        />
                      </div>
                    ))}
                  </div>
                </div>
                <Button size='large' text={t('global.send')} handleClick={sendMessage} customStyle={styles.submit} />
                {(messageLoading || loadingFile) && <Spinner />}
              </div>
            </ShowMoreCompoents>
          </div>
        ) : loading ? (
          <Spinner />
        ) : null}
      </div>
    </PageContainer>
  )
}

export default TicketDetails
